import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../fonts/AkkuratLL-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../fonts/AkkuratLL-Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22light%22}],%22variable%22:%22--font-sans%22}],%22variableName%22:%22AkkuratLL%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'AkkuratLL', 'AkkuratLL Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
